import {CssBaseline, ThemeProvider, createTheme} from '@mui/material';
import {GoogleOAuthProvider} from '@react-oauth/google';
import React from 'react';
import {createRoot} from 'react-dom/client';

import {App} from './App';
import {googleClientId} from './lib/auth';

import './styles/colors_and_type.css';
import './styles/grants.css';

const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {main: '#0000C5', dark: '#000093'},
        error: {main: '#FC5943'},
        warning: {main: '#C78600'},
        background: {default: 'hsla(218, 67%, 98%, 1)', paper: '#FFFFFF'},
        divider: 'hsla(217, 68%, 94%, 1)',
    },
    shape: {borderRadius: 8},
    typography: {
        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        button: {textTransform: 'none', fontWeight: 500},
    },
});

const root = createRoot(document.getElementById('root')!);
root.render(
    <React.StrictMode>
        <GoogleOAuthProvider clientId={googleClientId}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                <App />
            </ThemeProvider>
        </GoogleOAuthProvider>
    </React.StrictMode>
);
